import React, { useEffect, useState } from "react";
import DashboardLayout from "@/components/lingo/DashboardLayout";
import api from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";

export default function Profile() {
  const { user, setUser } = useAuth();
  const [data, setData] = useState({
    test_type: user?.test_type || "",
    target_score: user?.target_score || "",
    current_level: user?.current_level || "",
    country: user?.country || "",
    learning_mode: user?.learning_mode || "",
  });
  const [saving, setSaving] = useState(false);

  const save = async () => {
    setSaving(true);
    try {
      const r = await api.post("/auth/onboarding", data);
      setUser(r.data);
      toast.success("Profile updated");
    } catch { toast.error("Failed"); }
    finally { setSaving(false); }
  };

  return (
    <DashboardLayout title="Profile">
      <div className="max-w-2xl bg-white border border-slate-200 rounded-3xl p-7 space-y-4">
        <div className="text-xs font-mono uppercase tracking-widest text-slate-400">Account</div>
        <div className="flex items-center gap-4">
          <div className="w-14 h-14 rounded-full bg-gradient-to-br from-[#003049] to-[#0C4B66] flex items-center justify-center text-xl">{user?.name?.[0]}</div>
          <div>
            <div className="font-display text-xl">{user?.name}</div>
            <div className="text-sm text-slate-500">{user?.email}</div>
          </div>
        </div>
        <hr className="border-slate-200 my-3" />
        <Field label="Test type">
          <select value={data.test_type} onChange={(e) => setData({ ...data, test_type: e.target.value })} data-testid="profile-test" className="bg-[#F6F8FB]/50 border border-slate-200 rounded-xl px-4 py-2.5 w-full">
            <option value="IELTS_ACADEMIC">IELTS Academic</option>
            <option value="IELTS_GENERAL">IELTS General</option>
            <option value="PTE">PTE</option>
            <option value="OXFORD_ELLT">Oxford ELLT</option>
            <option value="DUOLINGO">Duolingo</option>
          </select>
        </Field>
        <Field label="Target score">
          <input value={data.target_score} onChange={(e) => setData({ ...data, target_score: e.target.value })} data-testid="profile-target" className="bg-[#F6F8FB]/50 border border-slate-200 rounded-xl px-4 py-2.5 w-full" />
        </Field>
        <Field label="Current level">
          <select value={data.current_level} onChange={(e) => setData({ ...data, current_level: e.target.value })} className="bg-[#F6F8FB]/50 border border-slate-200 rounded-xl px-4 py-2.5 w-full">
            <option value="BEGINNER">Beginner</option>
            <option value="INTERMEDIATE">Intermediate</option>
            <option value="ADVANCED">Advanced</option>
          </select>
        </Field>
        <Field label="Country / university">
          <input value={data.country} onChange={(e) => setData({ ...data, country: e.target.value })} className="bg-[#F6F8FB]/50 border border-slate-200 rounded-xl px-4 py-2.5 w-full" />
        </Field>
        <button onClick={save} disabled={saving} data-testid="profile-save" className="mt-3 bg-[#F77F00] text-white rounded-xl px-5 py-2.5">{saving ? "Saving..." : "Save"}</button>
      </div>
    </DashboardLayout>
  );
}

const Field = ({ label, children }) => (
  <div>
    <div className="text-xs uppercase tracking-widest text-slate-400 mb-1">{label}</div>
    {children}
  </div>
);
